import React from "react";
import { Badge } from "../../ui/badge";
import { BADGE_DATA } from "@/data/linksData";

const FooterBadges = () => {
    return (
        <div className="flex flex-wrap gap-2">
            {BADGE_DATA.map(({ label, icon: Icon, className }) => (
                <Badge key={label} variant="secondary" className={className}>
                    <Icon className="mr-1 h-4 w-4" />
                    {label}
                </Badge>
            ))}
        </div>
    );
};

export default FooterBadges;
